import React, { useRef } from "react";

import * as S from "./styles";

export const Slide7: React.FC = () => {
  const videoRef = useRef<HTMLVideoElement>(null);

  return (
    <S.Container>
      <S.Credit>Top, R$ 579, e saia, R$ 1.680, ambos À La Garçonne.</S.Credit>
      <S.Video>
        <video ref={videoRef} muted autoPlay loop playsInline>
          <source
            src="https://player.vimeo.com/external/538846332.hd.mp4?s=d86aeb336f391a9485a4d480f2a099219b18e331&profile_id=175&download=1"
            type="video/mp4"
          />
        </video>
      </S.Video>
    </S.Container>
  );
};
